import React, { useState, useEffect } from 'react';
import ShopHeader from './ShopHeader';
import ProductGrid from './ProductGrid';
import { useApp } from '../../../contexts/AppContext';

const ProductList2: React.FC = () => {
    // Shared state for filtering/sorting/layout
    const [showLimit, setShowLimit] = useState(75);
    const [viewGrid, setViewGrid] = useState(4);
    const [sortOption, setSortOption] = useState('default');
    const [isLoading, setIsLoading] = useState(false);

    const { filteredProducts } = useApp();

    // Trigger loading when filters or view changes
    useEffect(() => {
        setIsLoading(true);
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 600); // Small delay for UX feel
        return () => clearTimeout(timer);
    }, [showLimit, sortOption, filteredProducts]);

    return (
        <div style={{ position: 'relative', minHeight: '400px' }}>
            <ShopHeader
                showLimit={showLimit}
                setShowLimit={setShowLimit}
                viewGrid={viewGrid}
                setViewGrid={setViewGrid}
                sortOption={sortOption}
                setSortOption={setSortOption}
            />
            <ProductGrid
                showLimit={showLimit}
                viewGrid={viewGrid}
                sortOption={sortOption}
                isLoading={isLoading}
            />
        </div>
    );
};

export default ProductList2;
